import * as STD                                         from '@emersya/mpa-std-lib';
import CM                                               from '@emersya/mpa-components-manager-lib';

export interface IInputBoolComponentConfiguration extends IInputComponentConfiguration<
	boolean,
	boolean
>
{
	type : string;
};

export interface IInputBoolComponentConfigurationYesno extends IInputBoolComponentConfiguration {
	type : 'yesno';
};

export interface IInputBoolComponentConfigurationCheckbox extends IInputBoolComponentConfiguration {
	type : 'checkbox';
};
export type TInputBoolConfiguration = (
	IInputBoolComponentConfigurationYesno |
	IInputBoolComponentConfigurationCheckbox
	);

export class InputBoolComponent extends InputComponent<
	HTMLDivElement,
	boolean,
	boolean,
	InputBoolComponent,
	TInputBoolConfiguration
>
{
	component_DOM : HTMLDivElement;

	private async onClick() {
		await this.updateValue(!this.value);
	};

	async reset() {
		await this.updateValue(this.component_configuration.defaultValue || null);
	};

	override isValueTheDefault() {
		return (this.value === this.defaultValue);
	};

	private onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		if (ev.details.oldValue !== null) {
			STD.DOM.qs(this.component_DOM, '.selected').classList.remove('selected');
		}
		if (ev.details.newValue !== null) {
			if (ev.details.newValue) {
				STD.DOM.qs(this.component_DOM, '.yes').classList.add('selected');
			} else {
				STD.DOM.qs(this.component_DOM, '.no').classList.add('selected');
			}
		}
	};

	override deserialize(x : boolean | null) {
		return (!!x);
	};

	serialize() {
		return this.value;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : TInputBoolConfiguration
	)
	{
		if (!configuration[ '@translations' ]) {
			configuration[ '@translations' ] = {};
		}
		if (!configuration[ '@translations' ].unchecked) {
			configuration[ '@translations' ].unchecked = {
				'en' : 'No',
				'fr' : 'Non'
			};
		}
		if (!configuration[ '@translations' ].checked) {
			configuration[ '@translations' ].checked = {
				'en' : 'Yes',
				'fr' : 'Oui'
			};
		}
		for (const langId of STD.translationsManager.languages) {
			if (!configuration[ '@translations' ].checked[ langId ]) {
				if (langId === 'fr') {
					configuration[ '@translations' ].checked[ langId ] = 'Oui';
				} else if (langId === 'en') {
					configuration[ '@translations' ].checked[ langId ] = 'Yes';
				} else {
					configuration[ '@translations' ].checked[ langId ] = configuration[ '@translations' ].checked[ 'en' ] || '';
				}
			}
			if (!configuration[ '@translations' ].unchecked[ langId ]) {
				if (langId === 'fr') {
					configuration[ '@translations' ].unchecked[ langId ] = 'Non';
				} else if (langId === 'en') {
					configuration[ '@translations' ].unchecked[ langId ] = 'No';
				} else {
					configuration[ '@translations' ].unchecked[ langId ] = configuration[ '@translations' ].unchecked[ 'en' ] || '';
				}
			}
		}
		super(descriptor, configuration);
		if (![ 'yesno', 'checkbox' ].includes(configuration.type)) {
			throw STD.errors.user('type not defined!', {
				component : this,
				configuration
			});
		}
		const noChilds : STD.DOM.IFactoryNodePartialDescriptor[] = [
			{
				classList : [ 'checkbox' ]
			}
		];
		const yesChilds : STD.DOM.IFactoryNodePartialDescriptor[] = [
			{
				classList : [ 'checkbox' ]
			}
		];
		if (configuration.type === 'yesno') {
			noChilds.push({
				classList :  [ 'text' ],
				attributes : {
					'data-translation' : this.component_getTranslationId('unchecked') as string
				}
			});
		}
		if (configuration.type === 'yesno') {
			yesChilds.unshift({
				classList :  [ 'text' ],
				attributes : {
					'data-translation' : this.component_getTranslationId('checked') as string
				}
			});
		}
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			events : {
				click : this.onClick.bind(this)
			},
			childs : [
				{
					tag :       'button',
					classList : [ 'no' ],
					childs :    noChilds
				}, {
					tag :       'button',
					classList : [ 'yes' ],
					childs :    yesChilds
				}
			]
		});
		this.addEventListener('value', this.onValueUpdated.bind(this), {
			subType :  'input-bool',
			listener : this
		});
	};
};
export namespace NS {
	export const Component = InputBoolComponent;
	export type Component = InputBoolComponent;
	export type Configuration = TInputBoolConfiguration;
}
;
import './InputBool.scss';
import { InputComponent, IInputComponentConfiguration } from '../Input/Input';

CM.declare({
	id :   'input-bool',
	type : InputBoolComponent
});
